'use strict';

var React = require('react'),
    PlayerTitle = require('../atoms/PlayerTitle'),
    BlurredBackground = require('../atoms/BlurredBackground'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    supportsPositionSticky = require('../utils/supportsPositionSticky'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    { PropTypes } = React;

require('./legacy/Stamp.less');
require('./AudioContainer.less');

var AudioContainer = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    background: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    cover: PropTypes.node.isRequired,
    trackList: PropTypes.node
  },

  className: 'stamp-AudioContainer',

  getCSSModifiers() {
    return {
      supportsSticky: supportsPositionSticky()
    };
  },

  render() {
    return (
      <div className={this.getClassName()}
           data-scroll-anchor>
        <div className='stamp-AudioContainer-container'>
          <div className='stamp-AudioContainer-bg'>
            <BlurredBackground background={this.props.background} />
          </div>

          <div className='stamp-AudioContainer-box'>
            <div className='stamp-AudioContainer-player'>
              {this.props.cover}
            </div>

            <div className='stamp-AudioContainer-meta'>
              <PlayerTitle title={this.props.title}
                           username={this.props.username}
                           duration={this.props.duration}
                           linkUrl={this.props.url} />

              {this.props.trackList}

            </div>
          </div>
        </div>
      </div>
    );
  }
});

module.exports = AudioContainer;



/** WEBPACK FOOTER **
 ** ./stamp/AudioContainer.jsx
 **/